/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CaretCircleLeft(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm21.35156,134.05469a7.99912,7.99912,0,1,1-10.70312,11.89062l-40-36a7.99734,7.99734,0,0,1,0-11.89062l40-36a7.99912,7.99912,0,1,1,10.70312,11.89062L115.96094,128Z" />
    </Svg>
  );
}

export default CaretCircleLeft;
